// src/components/project/SKIPER/chapters/Story.jsx
import React from 'react';
import teamimage from '../../../../images/laprensaaus.JPG';
import teaminach from '../../../../images/Grupal_INACH_1.jpg';
import teammega from '../../../../images/Grupal_Mega_2.jpg';

export default function Story() {
  return (
    <section
      id="story-content"
      className="chapter-section content-section"
    >
      <div className="chapter-content">
        
        {/* Título */}
        <h1 className="content-title">SKIPER</h1>

        {/* Imagen al inicio */}
        <img src={teamimage} alt="Team trabajando en el proyecto" className="chapter-image"/>
        {/* Nuevo contenido en varios párrafos */}
        <p>
          Everything began in 2024, when Natalia Wensioe, a student of Mechanical Engineering and Design Engineering at Adolfo Ibáñez University, 
          decided to combine her passions for robotics and the sea. Seeking a thesis project with real impact—and aiming to apply for a postgraduate 
          degree in engineering in the Netherlands—she proposed creating a robot capable of exploring aquatic ecosystems.
        </p>

        <p>
          With the support of Professor Paula Rojas, Director of Mechanical Engineering, the project took shape as a Directed Research Workshop (TID). 
          Instead of waiting to finish her degree, Natalia immediately began studying the Antarctic ecosystem, understanding its conditions, challenges, and scientific potential.
        </p>
        <img src={teammega} alt="Team Mega" className="chapter-image"/>
        <p>
          During this process, the project grew and strengthened with the incorporation of three more students from different disciplines: 
          Nicomedes Pommier (Mechanical Engineering & Design Engineering) and Nicole Castro (Bioengineering). 
          This diversity gave the team a broader and deeper vision, and together they began to imagine a new way of exploring without leaving a trace. 
          Thus, SKIPER was born, a nature-inspired underwater exploration soft robot, silent and non-invasive, designed to support scientific research without altering the environment.
        </p>

        <p>
          In the second semester of 2024, the team began a second TID focused on materials and hydrodynamics and developed the first functional prototype of SKIPER. 
          It was then, thanks to an external recommendation, that they decided to apply for the Corfo Sustainable Seed fund. In February 2025, the project was awarded, 
          marking a key milestone in its development.
        </p>
        <img src={teaminach} alt="Team Inach" className="chapter-image"/>
        <p>
          Since then, SKIPER has captured national attention. 
          The project's story was covered in the press, television, and radio. 
          The team was invited to attend AquaSur Tech, the world's most important aquaculture fair, 
          in Punta Arenas, where they also held a meeting with the Chilean Antarctic Institute’s director (INACH).
        </p>
        
        <p>
          Currently, the startup seeks to develop a high-fidelity prototype that can be tested in controlled environments simulating the Antarctic conditions to which it would be exposed.
        </p>
      </div>
    </section>
  );
}
